import Vue from "vue";
import Vuex from "vuex";
import { axiosInstance } from "@/plugins/axios-instance";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuOpen: false,
    isLoading: false,
    isDesktop: null,
    lang: ["pt-pt", "en", "es"],
    langActive: "pt-pt",
    typesComponentsDefault: [
      {
        type: "banners",
        component: "Banner",
      },
      {
        type: "solutions",
        component: "SolutionsTab",
      },
      {
        type: "highlights",
        component: "BlogHighlights",
      },
      {
        type: "form",
        component: "FormContact",
      },
      {
        type: "faqs",
        component: "Faqs",
      },
      {
        type: "comp_text_logo_desc",
        component: "DetailsProduct",
      },
      {
        type: "comp_title_cards",
        component: "Features",
      },
      {
        type: "comp_img_right_left",
        component: "Solutions",
      },
      {
        type: "comp_title_img",
        component: "TitleAndImage",
      },
      {
        type: "comp_only_text",
        component: "MoreInformationPurchase",
      },
      {
        type: "comp_only_cards",
        component: "OptionsProduct",
      },
      {
        type: "licenses",
        component: "Plans",
      },
    ],
    headerLinks: [],
    dataPage: {},
  },
  getters: {
    menuOpen(state) {
      return state.menuOpen;
    },
    isLoading(state) {
      return state.isLoading;
    },
    isDesktop(state) {
      return state.isDesktop;
    },
    lang(state) {
      return state.lang;
    },
    langActive(state) {
      return localStorage.getItem("zs-locale") || state.langActive;
    },
    typesComponentsDefault(state) {
      return state.typesComponentsDefault;
    },
    headerLinks(state) {
      return state.headerLinks;
    },
    dataPage(state) {
      return state.dataPage;
    },
  },
  mutations: {
    setMenuOpen(state, value) {
      state.menuOpen = value;
      document.body.classList.toggle("overflow-hidden");
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    setIsDesktop(state, value) {
      state.isDesktop = value;
    },
    setLangActive(state, value) {
      state.langActive = value;
    },
    setTypesComponentsDefault(state, value) {
      state.typesComponentsDefault = value;
    },
    setHeaderLinks(state, value) {
      state.headerLinks = value;
    },
    setDataPage(state, value) {
      state.dataPage = value;
    },
  },
  actions: {
    setIsLoading(context, value) {
      context.commit("setIsLoading", value);
    },
    setMenuOpen(context, value) {
      context.commit("setMenuOpen", value);
    },
    setLangActive(context, value) {
      localStorage.setItem("zs-locale", value);
      context.commit("setLangActive", value);
    },
    setHeaderLinks(context, value) {
      context.commit("setHeaderLinks", value);
    },
    async getDataPage(context, url) {
      if (url === "obrigado") {
        url = window.location.href;
        url = url.replace(/\/obrigado$/, "");
      }

      // se url terminar em /obrigado, remove a parte final
      if (url.endsWith("#obrigado")) {
        url = url.slice(0, -"#obrigado".length);
      }

      const { data } = await axiosInstance({
        method: "POST",
        url: "/page",
        data: {
          url: url,
        },
      });

      context.commit("setDataPage", data?.data);
    },
    async getDataLegalInformation(context, slug) {
      const { data } = await axiosInstance({
        method: "POST",
        url: "/legal-information",
        data: {
          slug: slug,
        },
      });

      context.commit("setDataPage", data?.data);
    },
    async sendFormContact(context, formData) {
      const { data } = await axiosInstance({
        method: "POST",
        url: "/form",
        data: {
          form: formData,
        },
      });

      return data;
    },
  },
  modules: {},
});
